<!-- Navigation Menu -->
<nav class="navbar navbar-expand-lg fixed-top shadow-sm py-2" style="background-color: rgba(255, 255, 255, 0.95);">
  <div class="container-fluid px-5">
    <a href="#">
      <img src="assets/images/logo.png" alt="E-Cidadania Logo" height="80">
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
      <ul class="navbar-nav align-items-center">
        <li class="nav-item mx-3">
          <a class="nav-link px-3 fw-medium" (click)="scrollToSection('servicos')" style="cursor: pointer; font-size: 1.05rem; transition: color 0.3s ease; color: #333;">Serviços</a>
        </li>
        <li class="nav-item mx-3">
          <a class="nav-link px-3 fw-medium" (click)="scrollToSection('como-funciona')" style="cursor: pointer; font-size: 1.05rem; transition: color 0.3s ease; color: #333;">Como Funciona</a>
        </li>
        <li class="nav-item mx-3">
          <a class="nav-link px-3 fw-medium" (click)="scrollToSection('depoimentos')" style="cursor: pointer; font-size: 1.05rem; transition: color 0.3s ease; color: #333;">Depoimentos</a>
        </li>
        <li class="nav-item mx-3">
          <a class="nav-link px-3 fw-medium" (click)="scrollToSection('contato')" style="cursor: pointer; font-size: 1.05rem; transition: color 0.3s ease; color: #333;">Contato</a>
        </li>
        <li class="nav-item ms-3">
          <button class="btn btn-outline-dark px-4 fw-medium" style="font-size: 1.05rem; border-width: 2px; transition: all 0.3s ease;" (click)="login()">Login</button>
        </li>
      </ul>
    </div>
  </div>
</nav>

<style>
.nav-link:hover {
  color: #666 !important;
}

.btn-outline-dark:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  background-color: #333;
  color: white;
}

.navbar {
  border-bottom: 1px solid rgba(0,0,0,0.05);
  backdrop-filter: blur(5px);
}

.feature-card {
  text-align: center;
  padding: 2rem;
  border-radius: 16px;
  background: rgba(21, 54, 88, 0.02);
  border: 1px solid rgba(21, 54, 88, 0.05);
  transition: all 0.3s ease;
  height: 100%;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(21, 54, 88, 0.08);
  background: rgba(21, 54, 88, 0.04);
}

.feature-icon {
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  background: linear-gradient(135deg, #153658 0%, #1a4370 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  transition: all 0.3s ease;
}

.feature-card:hover .feature-icon {
  transform: scale(1.1);
}

.feature-card h3 {
  color: #153658;
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.feature-card p {
  color: #666;
  font-size: 1rem;
  line-height: 1.6;
}

.step-card {
  text-align: center;
  padding: 2rem;
  border-radius: 16px;
  background: rgba(21, 54, 88, 0.02);
  border: 1px solid rgba(21, 54, 88, 0.05);
  transition: all 0.3s ease;
  height: 100%;
  position: relative;
}

.step-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(21, 54, 88, 0.08);
  background: rgba(21, 54, 88, 0.04);
}

.step-number {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #153658 0%, #1a4370 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 auto 1.5rem;
  transition: all 0.3s ease;
}

.step-card:hover .step-number {
  transform: scale(1.1);
}

.step-card h3 {
  color: #153658;
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.step-card p {
  color: #666;
  font-size: 1rem;
  line-height: 1.6;
}

.testimonial-card {
  background: rgba(21, 54, 88, 0.02);
  border: 1px solid rgba(21, 54, 88, 0.05);
  border-radius: 16px;
  padding: 2rem;
  transition: all 0.3s ease;
  height: 100%;
}

.testimonial-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(21, 54, 88, 0.08);
  background: rgba(21, 54, 88, 0.04);
}

.testimonial-content {
  color: #153658;
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  font-style: italic;
}

.testimonial-author {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.author-image {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
}

.author-info h4 {
  color: #153658;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
}

.author-info p {
  color: #666;
  font-size: 0.9rem;
  margin: 0;
}

@media (max-width: 768px) {
  .feature-card,
  .step-card,
  .testimonial-card {
    margin-bottom: 1.5rem;
  }
  
  .feature-icon,
  .step-number {
    font-size: 2rem;
  }
  
  .feature-card h3,
  .step-card h3 {
    font-size: 1.25rem;
  }
}

.btn-primary {
  background: linear-gradient(135deg, #153658 0%, #1a4370 100%);
  border: none;
  color: white;
  font-weight: 500;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(21, 54, 88, 0.15);
}

.btn-primary:hover {
  background: linear-gradient(135deg, #1a4370 0%, #153658 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(21, 54, 88, 0.2);
  color: white;
}

.btn-primary:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(21, 54, 88, 0.15);
}

.btn-outline-primary {
  background: transparent;
  border: 2px solid #153658;
  color: #153658;
  font-weight: 500;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.btn-outline-primary:hover {
  background: linear-gradient(135deg, #153658 0%, #1a4370 100%);
  border-color: transparent;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(21, 54, 88, 0.2);
}

.btn-outline-primary:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(21, 54, 88, 0.15);
}

.hero-buttons {
  margin-top: 2rem;
}

.hero-buttons .btn {
  margin-right: 1rem;
  font-size: 1.1rem;
}

.cta-section {
  background-color: #153658;
  padding: 5rem 0;
  position: relative;
  overflow: hidden;
}

.cta-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%);
  pointer-events: none;
}

.cta-content {
  position: relative;
  z-index: 1;
}

.cta-content h2 {
  color: #ffffff;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  letter-spacing: -0.5px;
}

.cta-content p {
  color: rgba(255, 255, 255, 0.85);
  font-size: 1.2rem;
  margin-bottom: 2.5rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
}

.cta-section .btn-primary {
  background: #ffffff;
  color: #153658;
  font-weight: 600;
  padding: 1rem 3.5rem;
  font-size: 1.2rem;
  border: none;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.cta-section .btn-primary:hover {
  background: #f8f9fa;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  color: #153658;
}

.cta-section .btn-primary:active {
  transform: translateY(0);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
  .cta-section {
    padding: 4rem 1.5rem;
  }
  
  .cta-content h2 {
    font-size: 2rem;
  }
  
  .cta-content p {
    font-size: 1.1rem;
    margin-bottom: 2rem;
  }
  
  .cta-section .btn-primary {
    width: 100%;
    padding: 0.875rem 2rem;
  }
}

html {
  scroll-behavior: smooth;
}

.nav-link {
  position: relative;
}

.nav-link::after {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  bottom: -2px;
  left: 50%;
  background-color: #153658;
  transition: all 0.3s ease;
  transform: translateX(-50%);
}

.nav-link:hover::after {
  width: 100%;
}

.nav-link:hover {
  color: #153658 !important;
}
</style>

<!-- Add margin-top to account for fixed navbar -->
<div class="landpage-container" style="margin-top: 76px;">
  <!-- Hero Section -->
  <section class="hero-section">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <h1 class="hero-title">Bem-vindo ao E-Cidadania</h1>
          <p class="hero-subtitle">Sua plataforma completa para serviços jurídicos e cidadania</p>
          <div class="hero-buttons">
            <button class="btn btn-primary btn-lg" routerLink="/cliente">Começar Agora</button>
            <!--<button class="btn btn-outline-primary btn-lg">Saiba Mais</button>-->
          </div>
        </div>
        <div class="col-lg-6">
          <img src="assets/images/banner.png" alt="Hero Image" class="img-fluid hero-image">
        </div>
      </div>
    </div>
  </section>

  <!-- Features Section -->
  <section id="servicos" class="features-section">
    <div class="container">
      <h2 class="section-title text-center">Nossos Serviços</h2>
      <div class="row">
        <div class="col-md-4">
          <div class="feature-card">
            <div class="feature-icon">
              <i class="fas fa-balance-scale" style="color: #153658;"></i>
            </div>
            <h3>Advocacia</h3>
            <p>Conectamos você aos melhores advogados especializados em cidadania italiana.</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="feature-card">
            <div class="feature-icon">
              <i class="fas fa-language" style="color: #153658;"></i>
            </div>
            <h3>Tradução</h3>
            <p>Serviços de tradução juramentada para todos os seus documentos.</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="feature-card">
            <div class="feature-icon">
              <i class="fas fa-file-alt" style="color: #153658;"></i>
            </div>
            <h3>Documentação</h3>
            <p>Auxílio completo na preparação e organização de documentos.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- How It Works Section -->
  <section id="como-funciona" class="how-it-works-section">
    <div class="container">
      <h2 class="section-title text-center">Como Funciona</h2>
      <div class="row">
        <div class="col-md-3">
          <div class="step-card">
            <div class="step-number">1</div>
            <h3>Cadastro</h3>
            <p>Crie sua conta e preencha seus dados básicos.</p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="step-card">
            <div class="step-number">2</div>
            <h3>Documentação</h3>
            <p>Envie seus documentos para análise.</p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="step-card">
            <div class="step-number">3</div>
            <h3>Processamento</h3>
            <p>Nossa equipe analisa e processa sua solicitação.</p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="step-card">
            <div class="step-number">4</div>
            <h3>Conclusão</h3>
            <p>Acompanhe o status do seu processo em tempo real.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Testimonials Section -->
  <section id="depoimentos" class="testimonials-section">
    <div class="container">
      <h2 class="section-title text-center">Depoimentos</h2>
      <div class="row">
        <div class="col-md-4">
          <div class="testimonial-card">
            <div class="testimonial-content">
              <p>"Excelente serviço! O processo foi muito mais simples do que eu imaginava."</p>
            </div>
            <div class="testimonial-author">
              <img src="assets/images/user/avatar-1.jpg" alt="Author" class="author-image">
              <div class="author-info">
                <h4>Maria Silva</h4>
                <p>São Paulo, SP</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="testimonial-card">
            <div class="testimonial-content">
              <p>"Profissionais muito competentes e atenciosos. Recomendo!"</p>
            </div>
            <div class="testimonial-author">
              <img src="assets/images/user/avatar-2.jpg" alt="Author" class="author-image">
              <div class="author-info">
                <h4>João Santos</h4>
                <p>Rio de Janeiro, RJ</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="testimonial-card">
            <div class="testimonial-content">
              <p>"Plataforma intuitiva e suporte excepcional. Valeu cada centavo!"</p>
            </div>
            <div class="testimonial-author">
              <img src="assets/images/user/avatar-3.jpg" alt="Author" class="author-image">
              <div class="author-info">
                <h4>Ana Costa</h4>
                <p>Belo Horizonte, MG</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- CTA Section -->
  <section class="cta-section" id="contato">
    <div class="container">
      <div class="cta-content text-center">
        <h2>Pronto para começar sua jornada?</h2>
        <p>Junte-se a milhares de pessoas que já conquistaram sua cidadania italiana através do E-Cidadania.</p>
        <button class="btn btn-primary btn-lg" routerLink="/cliente">Começar Agora</button>
      </div>
    </div>
  </section>
</div>

